



















import { Project, getAssignedProjects } from "@/api/project-api";
import SelectOption from "@/common/ui/presenters/select-option";
import {
  getProjectStatusCode,
  ProjectStatusTypes
} from "@/models/project-status";
import { Component, Vue } from "vue-property-decorator";

export interface SearchDashboardProjectQuery {
  keyword: string;
  status: string;
  projectCount?: number;
}

@Component({})
export default class SearchDashboardProjectBar extends Vue {
  query: SearchDashboardProjectQuery = {
    keyword: "",
    status: String(getProjectStatusCode("施工中"))
  };

  get statusOptions(): SelectOption[] {
    return [
      {
        text: "全て",
        value: ""
      }
    ].concat(
      ProjectStatusTypes.map(t => ({
        text: t,
        value: String(getProjectStatusCode(t))
      }))
    );
  }

  public created() {
    // このやり方イマイチかも。
    // 親でもquery持って親でgetした方がいい？
    this.search();
  }

  async search() {
    let projects: Project[] = [];
    if (!this.query.status) {
      projects = await getAssignedProjects(
        this.query.keyword,
        this.query.status,
        projects.length
      );
    } else {
      projects = await getAssignedProjects(
        this.query.keyword,
        this.query.status
      );
    }
    this.$emit("search", projects, this.query.status, this.query.keyword);
  }
}
